import { useState } from 'react'
import { supabase } from '../../../../lib/supabase'
import { notifyAllSupporters } from '../../../../lib/notificationHelpers'

const CLUB_ID = 'a0000000-0000-0000-0000-000000000001'

export default function CampaignForm({ campaign, onClose, onRefresh }) {
  const [formData, setFormData] = useState({
    title: campaign?.title || '',
    description: campaign?.description || '',
    target_amount: campaign?.target_amount || '',
    status: campaign?.status || 'active',
  })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError(null)

    const payload = {
      title: formData.title,
      description: formData.description,
      target_amount: Number(formData.target_amount),
      status: formData.status,
      club_id: CLUB_ID,
    }

    const { error } = campaign
      ? await supabase.from('welfare_campaigns').update(payload).eq('id', campaign.id)
      : await supabase.from('welfare_campaigns').insert(payload)

    if (error) { setError(error.message); setLoading(false); return }

    if (!campaign) {
      try {
        await notifyAllSupporters({
          clubId: CLUB_ID,
          title: 'New Welfare Campaign',
          message: `A new campaign has been created: ${payload.title}`,
          type: 'campaign',
          link: '/welfare',
        })
      } catch (err) {
        console.error('Notification failed:', err)
      }
    }

    onRefresh()
    onClose()
  }

  const inputClass = "bg-gray-100 dark:bg-gray-900 border border-gray-200 dark:border-white/10 focus:border-green-600 text-gray-900 dark:text-white px-4 py-3 text-sm outline-none transition-colors placeholder:text-gray-400 dark:placeholder:text-gray-600 w-full"
  const labelClass = "text-xs text-gray-500 uppercase tracking-widest font-semibold"

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 px-4">
      <div className="bg-white dark:bg-gray-950 border border-gray-200 dark:border-white/10 p-8 w-full max-w-lg">
        <div className="flex justify-between items-center mb-6">
          <h2 className="font-black text-xl uppercase tracking-tight text-gray-900 dark:text-white">
            {campaign ? 'Edit Campaign' : 'New Campaign'}
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors">✕</button>
        </div>

        {error && (
          <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800/50 text-red-600 dark:text-red-400 px-4 py-3 text-sm mb-4">{error}</div>
        )}

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <label className={labelClass}>Campaign Title</label>
            <input type="text" name="title" value={formData.title} onChange={handleChange} placeholder="Medical Support for..." required className={inputClass} />
          </div>
          <div className="flex flex-col gap-2">
            <label className={labelClass}>Description</label>
            <textarea name="description" value={formData.description} onChange={handleChange} placeholder="Describe the situation and how funds will be used..." rows={4} className={`${inputClass} resize-none`} />
          </div>
          <div className="flex flex-col gap-2">
            <label className={labelClass}>Target Amount (ZMW)</label>
            <input type="number" name="target_amount" value={formData.target_amount} onChange={handleChange} placeholder="5000" required min="1" className={inputClass} />
          </div>
          <div className="flex flex-col gap-2">
            <label className={labelClass}>Status</label>
            <select name="status" value={formData.status} onChange={handleChange} className={inputClass}>
              <option value="active">Active</option>
              <option value="closed">Closed</option>
            </select>
          </div>
          <div className="flex gap-3 mt-2">
            <button type="button" onClick={onClose} className="flex-1 border border-gray-200 dark:border-white/10 hover:border-gray-300 dark:hover:border-white/30 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white py-3 font-bold uppercase tracking-widest text-sm transition-colors">
              Cancel
            </button>
            <button type="submit" disabled={loading} className="flex-1 bg-green-600 hover:bg-green-700 disabled:bg-green-900 text-white py-3 font-bold uppercase tracking-widest text-sm transition-colors">
              {loading ? 'Saving...' : campaign ? 'Update Campaign' : 'Create Campaign'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}